<!--
 * @Author: maqian maqian@aeonmed.com
 * @Date: 2025-03-21 09:01:20
 * @LastEditors: maqian maqian@aeonmed.com
 * @LastEditTime: 2025-07-03 08:39:56
 * @FilePath: \shh-download\src\components\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="main-page">
        <div style="
        margin-top: 57px;
        margin-bottom: 22px;
        display: flex;
        justify-content: center;
        align-items: center;">
            <img src="../assets/logo.png" style="width: 44px; height: 44px;"/>
            <img src="../assets/谊安健康.png" style="width:123px; height: 22px; margin-left: 4px;"/>
            <span style="color: #CDFFF0;">(原睡呼呼)</span>
        </div>
        <img src="../assets/您的睡眠呼吸专家.png" style="width: 310px; height: 28px;"/>
        <div style="position: relative;  height: 328px; margin: 70px auto 61px auto;width: 280px;">
            <img src="../assets/white1.png" style="width: 210px;height: 320px; position: absolute; left: 0; top: 7px; z-index: 1;" />
            <img src="../assets/white2.png" style="width: 160px;height: 328px; position: absolute; left: 109px; top: 0; z-index: 2;" />
        </div>
        <div style="color: #FFFFFF; margin: 0 24px;">温馨提示：若当前链接无法直接跳转小程序，请使用微信扫描设备界面二维码或微信搜索‘谊安健康用户端’进行体验。</div>
  </div>
</template>
<script>
import { axios } from '@/utils/request'
export default {
  name: 'index',
  data () {
    return {
      pageName: ''
    }
  },
  created () {
    console.log(this.$route)
    const { SN = '' } = this.$route.query
    this.sn = SN
    this.queryIsBinding(SN)
  },
  methods: {
    queryIsBinding (sn) {
      if (!sn) {
        this.getScheme('package_support/guaranteeCard/addCard', `originPage=h5&status=add`)
      } else {
        axios.get(`/ecard-new/v1/WarrantyCard/judgeSn?sn=${sn}`).then(res => {
          console.log('res::', res)
          if (res && res.data === true) {
            alert('该设备已绑定电子保修卡，进入小程序继续使用吧~若非您本人绑定，请联系客服处理。')
            this.getScheme('pages/main/index', '')
          } else {
            this.getScheme('package_support/guaranteeCard/addCard', `sn=${sn}&originPage=h5&status=add`)
          }
        })
      }
    },

    getScheme (path, query) {
      axios.post('/user/weChat/generatescheme', {
        path: path,
        query: query,
        env_version: 'release' // 正式版为"release"，体验版为"trial"，开发版为"develop"
      }).then(res => {
        console.log('res::', res)
        if (res.data.openlink) {
          window.location.href = res.data.openlink
        } else {
          alert('跳转小程序失败')
        }
      })
    }
  }
}
</script>
<style>
.main-page{
  height: 100%;
  background: url(../assets/bg.png) no-repeat center center;
  background-size: cover;
  overflow: hidden;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue